export enum BookingReferenceType {
  None = 0,
  Band = 1 << 0,
  Table = 1 << 1
}

export const BookingReferenceTypeLabels: { [key: number]: string } = {
  [BookingReferenceType.None]: 'Referenz',
  [BookingReferenceType.Band]: 'Band',
  [BookingReferenceType.Table]: 'Tisch'
}
